/*
  assets/b2b-phone.js
  Phone field with country flag on the AMATA B2B application form.
  Library: intl-tel-input 25.12.5 (loaded from jsDelivr in the section).

  Markup it expects:
    <input type="tel" data-phone data-default-country="lv">   visible field, no name
    <input type="hidden" name="contact[Phone]" data-key="phone" data-phone-full>   what gets sent

  The section's submit handler calls window.AmataPhone.prepare(form) before checkValidity().
*/
(function () {
  var UTILS = 'https://cdn.jsdelivr.net/npm/intl-tel-input@25.12.5/build/js/utils.js';
  var ORDER = ['lv', 'lt', 'ee', 'fi', 'se', 'de', 'pl', 'gb', 'fr', 'nl'];

  function setup(input) {
    if (!window.intlTelInput || input.dataset.itiReady) return;
    input.dataset.itiReady = '1';

    var form = input.closest('form');
    var field = input.closest('.field');
    var label = field && field.querySelector('.field__label');

    var iti = window.intlTelInput(input, {
      initialCountry: (input.dataset.defaultCountry || 'lv').toLowerCase(),
      countryOrder: ORDER,
      separateDialCode: true,
      strictMode: true,                /* digits only, capped at the max length for the country */
      autoPlaceholder: 'off',          /* keep "Phone" so the theme's floating label works */
      validationNumberTypes: null,     /* accept landlines too, not only mobiles */
      loadUtils: function () { return import(UTILS); }
    });
    input._iti = iti;

    /* The theme's floating label needs to stay the input's next sibling */
    if (label) input.insertAdjacentElement('afterend', label);

    /*
      Line flag + dial code up with the typed number in every state.
      1. The dial code copies the input's exact font, so both sit on the same baseline.
      2. Empty and unfocused, the label is centred, so no shift. Focused or filled,
         the theme moves the text down by its padding, so the button moves the same amount.
      3. Recalculated after the theme's own padding transition ends, so the final
         position is always read, not a value from the middle of the animation.
    */
    var FONT = ['fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'letterSpacing', 'lineHeight', 'fontFeatureSettings'];
    var button = null;
    var code = null;
    var align = function () {
      var cs = getComputedStyle(input);
      if (label) label.style.left = cs.paddingLeft;
      button = button || (field && field.querySelector('.iti__selected-country'));
      code = code || (field && field.querySelector('.iti__selected-dial-code'));
      if (code) FONT.forEach(function (p) { code.style[p] = cs[p]; });
      if (!button) return;
      var raised = document.activeElement === input || input.value !== '';
      var offset = raised
        ? (parseFloat(cs.paddingTop) + parseFloat(cs.borderTopWidth) - parseFloat(cs.paddingBottom) - parseFloat(cs.borderBottomWidth)) / 2
        : 0;
      button.style.transform = 'translateY(' + offset + 'px)';
    };
    var queue = function () { requestAnimationFrame(align); };
    queue();
    ['focus', 'blur', 'input', 'countrychange', 'transitionend'].forEach(function (ev) {
      input.addEventListener(ev, queue);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queue);

    /* Company country → phone country, until the buyer starts typing a number */
    var country = form && form.querySelector('[data-country]');
    if (country) {
      country.addEventListener('change', function () {
        if (!input.value.trim() && country.value) iti.setCountry(country.value.toLowerCase());
      });
    }

    input.addEventListener('input', function () { input.setCustomValidity(''); });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-phone]').forEach(setup);
  }

  window.AmataPhone = {
    /* Validates the number and writes it in E.164 (+37126615747) to the hidden field */
    prepare: function (form) {
      var input = form.querySelector('[data-phone]');
      var hidden = form.querySelector('[data-phone-full]');
      if (!input) return;

      var raw = input.value.trim();
      var iti = input._iti;
      input.setCustomValidity('');

      if (!raw || !iti) { if (hidden) hidden.value = raw; return; }

      var utils = window.intlTelInput && window.intlTelInput.utils;
      if (utils && !iti.isValidNumber()) {
        input.setCustomValidity(input.dataset.invalidMsg || 'Please enter a valid phone number.');
        return;
      }
      var full = utils ? iti.getNumber() : '+' + iti.getSelectedCountryData().dialCode + ' ' + raw;
      if (hidden) hidden.value = full || raw;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  /* Theme editor re-renders the section */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
